// based on rc-calendar 9.7.9
import Calendar from './src/'
export default Calendar



// WEBPACK FOOTER //
// ./components/vc-calendar/index.js